// TODO: #646 refactor -- split/rename components

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import thirdBridgeConnectionLogo from '@assets/ThirdBridgeConnectionLogo.svg';
import colors from '@theme/colors';
import { watermarkType } from '@molecules/Watermark/prop-types';
import font from '@theme/font';
import { Button, DownloadLogo, Icon } from '@atoms';
import messages from './messages';

import { DownloadAudioButton, TranscriptSpeakersTooltip } from '@molecules';

const HeaderContainerStyled = styled.div`
  border-bottom-style: solid;
  border-bottom-width: 0.5px;
  border-bottom-color: ${colors.BLUE};
  background-color: ${colors.WHITE};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100px;
  padding: 5px 15px 5px 15px;
  height: 96px;
  margin-bottom: 30px;

  @media (max-width: 500px) {
    margin-bottom: 0;
    height: 60px;
  }
  @media print {
    display: none;
  }
`;

const HeaderWrapper = styled.div`
  width: 740px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 740px) {
    width: 100%;
  }
`;
const StyledImage = styled.img`
  height: 80px;
  width: 109px;

  @media (max-width: 500px) {
    height: 30px;
    width: 41px;
  }
`;

const StyledDownloadButton = styled(Button)`
  width: 210px;
  font-size: ${font.screen.size.MEDIUM};
`;
const StyledDownloadLogo = styled(DownloadLogo)``;

const OperationsContainer = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  > ${StyledDownloadLogo} {
    display: none;
  }

  @media (max-width: 500px) {
    > ${StyledDownloadButton} {
      display: none;
    }

    > ${StyledDownloadLogo} {
      display: inline-block;
      margin-top: 10px;
      position: absolute;
      right: 70px;
      top: 5px;
    }
  }
`;

const downloadPdfVersionIconStyle = {
  filter:
    'brightness(0) saturate(100%) invert(27%) sepia(74%) saturate(2029%) hue-rotate(167deg) brightness(98%) contrast(101%)',
  marginRight: '10px',
};

export class TranscriptHeader extends PureComponent {
  downloadAction = () =>
    this.props.download(this.props.downloadFileName, this.props.watermark);

  render() {
    const {
      speakers,
      changeSpeakerNames,
      transcriptId,
      isSuperAdmin,
      isAIRoute,
      shouldShowAudioDownloadButton,
    } = this.props;
    const isHumanTranscript = !isAIRoute;
    return (
      <HeaderWrapper>
        <StyledImage src={thirdBridgeConnectionLogo} />
        <OperationsContainer>
          {shouldShowAudioDownloadButton && <DownloadAudioButton />}
          <StyledDownloadButton onClick={this.downloadAction}>
            <Icon name="download" style={downloadPdfVersionIconStyle} />{' '}
            <FormattedMessage {...messages.downloadLabel} />
          </StyledDownloadButton>
          <StyledDownloadLogo onClick={this.downloadAction} />
          {isSuperAdmin && isHumanTranscript && (
            <TranscriptSpeakersTooltip
              speakers={speakers}
              changeSpeakerNames={changeSpeakerNames}
              transcriptId={transcriptId}
            />
          )}
        </OperationsContainer>
      </HeaderWrapper>
    );
  }
}

TranscriptHeader.propTypes = {
  downloadFileName: PropTypes.string,
  onClick: PropTypes.func,
  watermark: PropTypes.oneOfType([watermarkType, PropTypes.bool]),
  download: PropTypes.func.isRequired,
  locale: PropTypes.string,
  shouldShowAudioDownloadButton: PropTypes.bool,
  isSuperAdmin: PropTypes.bool,
};

export default class HeaderContainer extends PureComponent {
  render() {
    return (
      <HeaderContainerStyled>
        <TranscriptHeader
          onClick={window.history.back.bind(window.history)}
          {...this.props}
        />
      </HeaderContainerStyled>
    );
  }
}

HeaderContainer.propTypes = {
  downloadFileName: PropTypes.string,
  watermark: PropTypes.oneOfType([watermarkType, PropTypes.bool]),
  isAIRoute: PropTypes.bool,
  download: PropTypes.func.isRequired,
  locale: PropTypes.string,
  shouldShowAudioDownloadButton: PropTypes.bool,
};

HeaderContainer.defaultProps = {
  locale: 'en_GB',
};



// WEBPACK FOOTER //
// ./components/organisms/TranscriptHeader/TranscriptHeader.js